import { useQuery } from 'react-query';

import { getComponent as queryFn } from 'api/endPoints/getComponent';
import { QueryKeys } from 'api/queryKeys';

import { Widget } from 'components/Dashboards/Reporting/reporting.types';

export const useQueryGetComponent = (params: QueryParams) => {
    return useQuery<QueryFnResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getComponent', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.componentId),
        select: (data) => {
            return {
                ...data,
                params: data.params ? JSON.parse(data.params) : null,
            };
        },
    });
};

interface QueryParams {
    componentId: string | undefined;
}

type QueryFnResponse = Widget;

type QueryResponse = QueryFnResponse & {};
